import { useCallback, useMemo } from "react";
import { useTranslation } from "react-i18next";
import AUDIT_TRAIL_TYPES from "../../config/auditTrailTypes";
import OBJECT_TYPES from "../../config/objectTypes";
import Utils from "../../utils/utils";

const Timeline = ({ data }) => {
    const [translate] = useTranslation();

    const objects = useMemo(() => {
        const obj = {};
        for (let key in OBJECT_TYPES) {
            obj[OBJECT_TYPES[key]] = translate(`OTM_${key}`);
        }
        return obj;
    }, [translate]);

    const operationType = useMemo(() => {
        const obj = {};
        for (let key in AUDIT_TRAIL_TYPES) {
            obj[AUDIT_TRAIL_TYPES[key]] = key;
        }
        return obj;
    }, []);

    const getObjectIdentifier = useCallback((object, objectType) => {
        if (!object) {
            return "";
        }
        if (objectType === OBJECT_TYPES.USER) {
            return object.email;
        } else {
            return object.name;
        }
    }, []);

    const renderTimeLine = useMemo(() => {
        return data.map((item, index) => (
            <li key={index} className="list-group-item bg-light border-0 small mt-3 mt-lg-0 p-0 pt-lg-3 pb-lg-0 ps-lg-5 pe-lg-0">
                <div className="p-3 rounded bg-white">
                    <div className="row align-items-center mt-n2">
                        <div className="col-12 col-lg-6 mt-2">
                            <div className="badge bg-secondary p-2">{Utils.getFormattedDateTime(item.createdAt)}</div>
                        </div>
                        <div className="col-12 col-lg-6 mt-2 d-lg-flex justify-content-end">
                            <div className="badge bg-secondary p-2">{operationType[item.operationType]}</div>
                        </div>
                        <div className="col-12 mt-2 d-lg-flex align-items-center">
                            <div className="h6">{objects[item.objectType]}</div>
                            <div className="badge bg-secondary p-2 ms-lg-3 mt-1 mt-lg-0">{getObjectIdentifier(item.object, item.objectType)}</div>
                        </div>
                        {item.previousValue &&
                            <div className="col-12 col-lg-6 mt-2">
                                <div className="form-label h6">{translate("OTM_PREVIOUS_VALUES")}</div>
                                <textarea className="bg-light w-100" disabled={true} rows="5" value={JSON.stringify(item.previousValue, null, 2)} />
                            </div>}
                        <div className="col-12 col-lg-6 mt-2">
                            <div className="form-label h6">{translate("OTM_NEW_VALUES")}</div>
                            <textarea className="bg-light w-100" disabled={true} rows="5" value={JSON.stringify(item.newValue, null, 2)} />
                        </div>
                    </div>
                </div>
            </li>
        ));
    }, [data, operationType, objects, getObjectIdentifier, translate]);

    return (
        <ul className="list-group list-group-flush position-relative timeline">
            {renderTimeLine}
        </ul>
    );
};

export default Timeline;